export class ApiErrorException extends Error {
    public status: number;
    public statusText: string;
    public data: object;

    constructor(err: any) {
        super();
        this.name = "ApiError";
        this.status = err.status;
        this.statusText = err.statusText;
        this.data = err.body;
        this.message = err.response.message;
    }
}

export class NotImplementedException extends Error {
    public status: number;
    public statusText: string;
    public data: object;

    constructor(err: any) {
        super();
        this.name = "NotImplemented";
        this.status = err.status;
        this.statusText = err.statusText;
        this.data = err.body;
        this.message = err.response.message;
    }
}
